import {
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { IPRApprovalHistoryRecord, IPRInternHistoryVersion, PRInternHistoryItem } from 'src/app/models/proofreading-history.model';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { LivecoAPIService } from 'src/app/services/liveco-api.service';
import { LoaderService } from 'src/app/services/loader.service';
import { IVersionSelector, ProofreadingHistoryService } from 'src/app/services/proofreading-history.service';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ApprovalProofreadingCompareComponent } from '../approval-proofreading-compare/approval-proofreading-compare.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-intern-proofreading-compare',
    templateUrl: './intern-proofreading-compare.component.html',
    styleUrls: ['./intern-proofreading-compare.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class InternProofreadingCompareComponent extends ApprovalProofreadingCompareComponent {

    override get url() {
        return this.s_proofreadingHistories.compare.intern.url;
    }

    get VA(): IPRInternHistoryVersion | undefined {
        return this.s_proofreadingHistories.compare.intern.version_A.value;
    }
    set VA(value: IPRInternHistoryVersion | undefined) {
        this.s_proofreadingHistories.compare.intern.version_A.next(value);
    }

    get VB(): IPRInternHistoryVersion | undefined {
        return this.s_proofreadingHistories.compare.intern.version_B.value;
    }
    set VB(value: IPRInternHistoryVersion | undefined) {
        this.s_proofreadingHistories.compare.intern.version_B.next(value);
    }

    get internHistoryItems() {
        return this.s_proofreadingHistories.projectHistories.map((h) => h.intern).filter((h) => !!h) as PRInternHistoryItem[];
    };

    constructor(
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected route: ActivatedRoute,
        protected router: Router,
        protected liveco: LivecoAPIService,
        protected s_proofreading: ProofreadingService,
        protected s_proofreadingHistories: ProofreadingHistoryService,
        protected translate: TranslateService
    ) {
        super(route, router, s_alert, s_loader, s_auth, liveco, s_proofreading, s_proofreadingHistories);
        this.subscription.add(this.s_proofreadingHistories.compare.intern.version_A.subscribe(this.handleCompare.bind(this)));
        this.subscription.add(this.s_proofreadingHistories.compare.intern.version_B.subscribe(this.handleCompare.bind(this)));
    }

    override async handleCompare(version?: IPRApprovalHistoryRecord | IPRInternHistoryVersion) {
        const response = await this.liveco.find({ urlA: this.VA?.file_url || this.RA?.file_url, urlB: this.VB?.file_url || this.RB?.file_url }, "/proofscope/compare");
        this.url.next(response?.result || null);
    }

    override selected(document: 'A' | 'B', selection: IVersionSelector | null) {
        switch (document) {
            case 'A':
                this.selection['A'] = selection;
                if (!selection) {
                    this.VA = undefined;
                    this.RA = undefined;
                    return;
                }

                if (selection.version !== undefined) {
                    this.RA = undefined;
                    this.VA = this.internHistoryItems.find((h) => h.proofreadingID === selection.id)?.history[this.getPrefixRelecture(selection.flow).short + selection.relecture][selection.version];
                } else {
                    this.VA = undefined;
                    this.RA = this.approvalHistoryItems.find((h) => h.proofreadingID === selection.id)?.history[this.getPrefixRelecture(selection.flow).short + selection.relecture];
                }
                break;
            case 'B':
                this.selection['B'] = selection;
                if (!selection) {
                    this.VB = undefined;
                    this.RB = undefined;
                    return;
                }

                if (selection.version !== undefined) {
                    this.RB = undefined;
                    this.VB = this.internHistoryItems.find((h) => h.proofreadingID === selection.id)?.history[this.getPrefixRelecture(selection.flow).short + selection.relecture][selection.version];
                } else {
                    this.VB = undefined;
                    this.RB = this.approvalHistoryItems.find((h) => h.proofreadingID === selection.id)?.history[this.getPrefixRelecture(selection.flow).short + selection.relecture];
                }
                break;
        }
    }

}




